import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { IntervalInsightPage } from 'components/pages/intervals-report/page';
import { ProjectsReportPage } from 'components/pages/projects-report';
import { TemplateInsight } from 'components/pages/template-insight';
import { UsersReportPage } from 'components/pages/users-report';
import { RoutePaths } from 'constant';
import { CsatPage } from './csat';
import { ReportsListPage } from './list';
import { TimesheetsReportRoute } from './timesheets';

export const ReportsRoute: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <SecureRoute path={RoutePaths.csatReports}>
        <CsatPage />
      </SecureRoute>
      <SecureRoute path={RoutePaths.timesheetReports}>
        <TimesheetsReportRoute />
      </SecureRoute>
      <SecureRoute
        path={RoutePaths.projectsReport}
        component={ProjectsReportPage}
      />
      <SecureRoute path={RoutePaths.usersReport} component={UsersReportPage} />
      <SecureRoute
        path={RoutePaths.templateInsight}
        component={TemplateInsight}
      />
      <SecureRoute
        path={RoutePaths.intervalsReport}
        component={IntervalInsightPage}
      />
      <SecureRoute path={path} exact>
        <ReportsListPage />
      </SecureRoute>
    </Switch>
  );
};
